<section class="mat-typography mat-body mat-app-background">
  <mat-tab-group #tabGroup animationDuration="15ms">
    @for (page of selections; track page) {
      @if (page.componentRef) {
        <mat-tab [label]="page.label">
          <div class='dynamic-view-container'>
            <ng-template #dynamic></ng-template>
          </div>
        </mat-tab>
      }
    }
  </mat-tab-group>
</section>
